package com.tovtalk.ui.theme

import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp

@Immutable
data class TovTalkShapeSystem(
    val none: Shape,
    val extraSmall: Shape,
    val small: Shape,
    val medium: Shape,
    val large: Shape,
    val extraLarge: Shape,
    val full: Shape,
    val button: Shape,
    val buttonSmall: Shape,
    val card: Shape,
    val dialog: Shape,
    val sheet: Shape,
    val chip: Shape,
    val avatar: Shape,
    val thumbnail: Shape,
    val input: Shape,
    val badge: Shape,
    val tooltip: Shape,
)

val TovTalkShapes = TovTalkShapeSystem(
    none = RoundedCornerShape(0.dp),
    extraSmall = RoundedCornerShape(4.dp),
    small = RoundedCornerShape(8.dp),
    medium = RoundedCornerShape(12.dp),
    large = RoundedCornerShape(16.dp),
    extraLarge = RoundedCornerShape(24.dp),
    full = CircleShape,
    button = RoundedCornerShape(12.dp),
    buttonSmall = RoundedCornerShape(8.dp),
    card = RoundedCornerShape(16.dp),
    dialog = RoundedCornerShape(24.dp),
    sheet = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp),
    chip = RoundedCornerShape(20.dp),
    avatar = CircleShape,
    thumbnail = RoundedCornerShape(8.dp),
    input = RoundedCornerShape(12.dp),
    badge = RoundedCornerShape(10.dp),
    tooltip = RoundedCornerShape(8.dp),
)

val LocalTovTalkShapes = staticCompositionLocalOf { TovTalkShapes }
